import REGEX from './regex.js';
function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
export default validate;


// WEBPACK FOOTER //
// ./~/@psykhe-ai/browser-plugin-snowplow-ecommerce/~/uuid/dist/esm-browser/validate.js